import React from 'react';
import * as FiIcons from 'react-icons/fi';
import AgentGrid from './AgentGrid';
import CockpitKPIRow from './CockpitKPIRow';
import CronPreviewStrip from './CronPreviewStrip';
import EventFeed from './EventFeed';
import ClientRequestsFeed from './ClientRequestsFeed';
import useAppStore from '../../store';
import DataModeBadge from '../../components/feedback/DataModeBadge';

/**
 * Cockpit screen (T2a): KPI row → agent grid + live event rail →
 * client-requests feed → cron preview strip. Keeps the shared page-shell
 * classes (.page-content / .page-heading / .eyebrow / .primary-button).
 *
 * onOpenApprovals/approvalCount remain supported for the legacy route
 * wrapper, but the page also navigates internally via react-router.
 *
 * Cutover §3: the headline copy no longer fabricates a completion count
 * ("completed 147 tasks since midnight" was a mock literal) — the approval
 * count shown IS live (approvals slice over GET /api/approvals); the
 * subheading now states the honest aggregation posture.
 */
function CockpitPage({ onOpenApprovals, approvalCount }) {
  const agents = useAppStore((state) => state.agents);
  const agentsMode = useAppStore((state) => state.agentsMode);
  const storeApprovals = useAppStore((state) => state.approvals);
  const openApprovals = typeof onOpenApprovals === 'function'
    ? onOpenApprovals
    : CockpitPage.defaultOpenApprovals;
  const pendingCount = approvalCount ?? storeApprovals.length;

  return (
    <main className="page-content">
      <section className="page-heading">
        <div>
          <p className="eyebrow">LIVE OPERATIONS</p>
          <h1>Cockpit</h1>
          <span>
            Agency operations at a glance — approval queue and fleet state are
            live; every other panel is labeled by its data source.
          </span>
        </div>
        <button className="primary-button" onClick={openApprovals} type="button">
          <FiIcons.FiCheckSquare /> Review {pendingCount} approvals
        </button>
      </section>

      <CockpitKPIRow />

      <div className="cockpit-grid">
        <section>
          <div className="section-heading">
            <div>
              <h2>
                Agent fleet <DataModeBadge mode={agentsMode} />
              </h2>
              <span>Live heartbeat</span>
            </div>
            <button className="ghost-button" onClick={openApprovals} type="button">
              View all <FiIcons.FiArrowUpRight />
            </button>
          </div>
          <AgentGrid agents={agents} />
          <ClientRequestsFeed />
        </section>
        <EventFeed />
      </div>

      <CronPreviewStrip />
    </main>
  );
}

export default CockpitPage;
